module.exports = __webpack_public_path__ + "img/vip-3.53318395.png";